export const RPC_ORDER_ENDPOINTS = {
    INSERT_CUSTOMER_ORDER_DETAILS: "/insert_customer_order_details",
    GET_ORDER_LIST: "/get_order_list",
    GET_ORDER_DETAIL: "/get_order_detail",
    GET_ORDER_STATUS_LIST: "/get_order_status_list",
    GET_ORDER_DETAILS: "/get_order_details",
    GET_ORDER_SERIES_LIST: "/getorderserieslist_bytype",
};
